import React, { useState, useEffect } from 'react';
import api from '../api';
import { useToast } from '../Toast';

export default function NotificationSettingsPage() {
  const [recipients, setRecipients] = useState([]);
  const [email, setEmail] = useState('');
  const [label, setLabel] = useState('');
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const r = await api.get('/settings/notification-recipients');
      setRecipients(r.data);
    } catch { /* not admin or error, ignore */ }
  }

  async function handleAdd(e) {
    e.preventDefault();
    if (!email.trim()) return;
    setSaving(true);
    try {
      await api.post('/settings/notification-recipients', { email: email.trim(), label: label.trim() || null });
      setEmail(''); setLabel('');
      toast('Adres dodany do listy powiadomień');
      load();
    } catch (err) {
      toast(err.response?.data?.error || 'Błąd dodawania', 'error');
    } finally { setSaving(false); }
  }

  async function handleRemove(id) {
    if (!window.confirm('Usunąć ten adres z listy powiadomień?')) return;
    await api.delete(`/settings/notification-recipients/${id}`);
    toast('Adres usunięty');
    load();
  }

  return (
    <div>
      <h1 className="page-title">Powiadomienia e-mail</h1>

      <div className="card" style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>Adresy zawsze powiadamiane</h2>
        <p className="text-muted" style={{ marginBottom: 16 }}>
          Te adresy dostaną e-mail przy każdym komentarzu, nowej wersji pliku, usunięciu i przypomnieniu o przeglądzie — niezależnie od tego, której procedury to dotyczy.
        </p>

        <form onSubmit={handleAdd} style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
          <input className="form-input" style={{ flex: 2, minWidth: 200 }} type="email" placeholder="adres@wheeltrade.pl" value={email} onChange={e => setEmail(e.target.value)} required />
          <input className="form-input" style={{ flex: 1, minWidth: 140 }} placeholder="Opis (opcjonalnie)" value={label} onChange={e => setLabel(e.target.value)} />
          <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Dodawanie...' : '+ Dodaj'}</button>
        </form>

        {recipients.length === 0 ? (
          <div className="empty-state"><p>Brak dodatkowych adresów — powiadomienia trafiają tylko do właściciela, autora i opiekunów działów</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Email</th><th>Opis</th><th>Dodano</th><th></th></tr></thead>
              <tbody>
                {recipients.map(r => (
                  <tr key={r.id}>
                    <td style={{ fontWeight: 500 }}>{r.email}</td>
                    <td style={{ color: 'var(--gray-500)' }}>{r.label || '—'}</td>
                    <td style={{ color: 'var(--gray-400)', fontSize: 12.5 }}>{new Date(r.created_at).toLocaleDateString('pl-PL')}</td>
                    <td><button className="btn btn-danger btn-sm" onClick={() => handleRemove(r.id)}>Usuń</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="card">
        <h2 style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>Godzina przypomnień o przeglądzie</h2>
        <p className="text-muted">
          Godzinę wysyłki przypomnienia ustawia się indywidualnie dla każdej procedury — w formularzu edycji procedury, obok daty przeglądu. System sprawdza co 5 minut, czy nadszedł czas wysłać przypomnienie.
        </p>
      </div>
    </div>
  );
}
